import { Link } from 'react-router-dom'
import {
  getAnimeDetailsUrl,
  getAnimeImage,
} from '../../../services/util.service'
import { MinusIcon, PlusIcon, ThreeDots } from '../../ui/icons/shared'

export function WatchlistListView({
  items,
  canEdit,
  onIncrement,
  onDecrement,
  onRemove, // נשאר לשימוש עתידי אם תוסיף "מחק"
  onOpenEdit,
}) {
  return (
    <div className="w-full flex flex-col gap-5">
      {items.map((item) => (
        <div key={item.anizone_id} className="bg-[#252525]">
          <div className="flex items-center">
            {/* תמונה + שם האנימה */}
            <div className="flex w-[73%] items-center gap-5">
              <Link to={getAnimeDetailsUrl(item)}>
                <img
                  src={getAnimeImage(item)}
                  alt={item.title_english || item.title}
                  className="w-[100px] h-[80px] object-cover"
                />
              </Link>

              <Link
                to={getAnimeDetailsUrl(item)}
                className="hover:text-primary transition"
              >
                <span className="font-bold">{item.title_hebrew}</span>
                <br />
                <span className="text-muted">
                  {item.title_english || item.title}
                </span>
              </Link>
            </div>

            {/* פרטי השליטה */}
            <div className="flex justify-end items-center gap-5 w-full">
              {/* כפתורי פלוס/מינוס + התקדמות */}
              <div className="flex items-center gap-4">
                {canEdit && (
                  <>
                    <button
                      onClick={() => onDecrement(item)}
                      className="w-6 h-6 bg-accentLight rounded-full flex items-center justify-center"
                    >
                     <MinusIcon/>
                    </button>
                  </>
                )}

                <div>
                  <span className="text-muted">{item.episodes} / </span>
                  <span className="text-primary">{item.progress}</span>
                </div>

                {canEdit && (
                  <>
                    <button
                      onClick={() => onIncrement(item)}
                      className="w-6 h-6 bg-accentLight rounded-full flex items-center justify-center"
                    >
                     <PlusIcon/>
                    </button>
                  </>
                )}
              </div>

              {/* תאריך + כפתור עריכה */}
              <div className="flex items-center gap-5 ml-8">
                <span className="text-muted text-sm">
                  נוסף ב-{item.start_date}
                </span>

                {canEdit && (
                  <button
                    onClick={() => onOpenEdit(item)}
                    className="w-6 h-6 bg-secondaryBackground rounded-full flex items-center justify-center"
                  >
                    <ThreeDots />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
